/** Google Analytics 4 — ID вида G-XXXXXXXXXX */
export const GA_ID = process.env.REACT_APP_GA_ID?.trim() || '';

export const initAnalytics = () => {
  if (!GA_ID || typeof window.gtag === 'function') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
};

export const trackPageView = (path) => {
  if (!GA_ID || typeof window.gtag !== 'function' || !path) {
    return;
  }
  window.gtag('config', GA_ID, { page_path: path });
};
